
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.992 1.667c-4.6 0-8.325 3.733-8.325 8.333s3.725 8.334 8.325 8.334c4.608 0 8.342-3.734 8.342-8.334S14.6 1.667 9.992 1.667zm.008 15A6.665 6.665 0 013.334 10 6.665 6.665 0 0110 3.334 6.665 6.665 0 0116.667 10 6.665 6.665 0 0110 16.667zM9.767 5.834h.05c.333 0 .6.266.6.6v3.783l3.225 1.917a.592.592 0 01.208.825.594.594 0 01-.816.2l-3.459-2.075a.825.825 0 01-.408-.717V6.434c0-.334.267-.6.6-.6z","fill":"#9AA0B5"}})])
          )
        }
      }
    